import LocalStorage from '../../local-storage';
import Config from '../../config';

const setAuthToken = async (JWToken) => {
  try {
    LocalStorage.setItem(Config.LOCAL_STORAGE_AUTH_KEY, JWToken);
    return true;
  } catch (error) {
    // console.error('Failed to set JWtoken into async storage. Error:', error);
    return false;
  }
};

export default setAuthToken;
